<template>
  <div class="login">
    <div class="row justify-content-md-center">
      <div class="col-lg-3 col-12">
        <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
        <b-alert variant="success" show v-if="success">{{ success }}</b-alert>
        <br/>
        <div class="text-center">
          <div class="btn-group text-center">
            <b-button variant="info" disabled>
              <icon name="brands/twitter" v-if="!loader"></icon>
              <b-spinner small type="grow" variant="warning" v-if="loader"></b-spinner>
            </b-button>
            <b-button variant="info" v-on:click="twLogin()" v-if="!loader"> Se connecter avec Twitter</b-button>
            <b-button variant="info" v-if="loader"> Connexion...</b-button>
          </div>
        </div>
        <br/>
        <div class="row" v-if="show">
          <div class="col"><hr style="background: white;"></div>
          <div class="col-auto" style="color: white;">OU</div>
          <div class="col"><hr style="background: white;"></div>
        </div>
        <div v-if="show">
          <b-form @submit="onSubmit">
            <b-form-group id="input--group-email" label="Email:" label-for="input-email">
              <b-form-input
                id="input-email"
                v-model="form.email"
                type="email"
                placeholder="Adresse Email"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Mot de passe:" label-for="input-password">
              <b-form-input
                id="input-password"
                v-model="form.password"
                type="password"
                required
              ></b-form-input>
            </b-form-group>

            <div class="text-center">
              <b-button type="submit" variant="outline-light">
                <span v-if="!loader">Se connecter</span>
                <b-spinner small type="grow" variant="warning" v-if="loader"></b-spinner> <span v-if="loader">Connexion...</span>
              </b-button>
            </div>
          </b-form>
          <br/>
          <a href="#" @click="resetPassword()" >Mot de passe oublié ?</a>
          <router-link class="float-right" :to="{ name: 'creation-compte', query: { redirect: $route.query.redirect }}" >Créer un compte</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase.js'
import { auth } from '@/firebase.js'

export default {
  data: () => ({ form: { email: '', password: '' }, loader: false, auth: auth, show: true, error: null, success: null }),
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      if(this.loader) return;
      this.error = null
      this.success = null
      this.loader = true
      auth.signInWithEmailAndPassword(this.form.email, this.form.password).then(() => this.$router.replace(this.$route.query.redirect ? this.$route.query.redirect : '/')).catch((error) => {
        //error.code;
        this.loader = false
        if(error.code == 'auth/invalid-email') {
          this.error = "Email non valide"
        } else if(error.code == 'auth/user-not-found') {
          this.error = "Utilisateur introuvable"
        } else if(error.code == 'auth/wrong-password') {
          this.error = "Votre mot de passe est incorrect"
        } else {
          this.error = error.message
        }
        window.scrollTo(0,0);
      });
    },
    twLogin: function () {
      this.error = null
      this.show = false
      this.success = null
      this.loader = true
      var provider = new firebase.auth.TwitterAuthProvider();
      auth.signInWithPopup(provider).then(() => {
        this.$router.replace(this.$route.query.redirect ? this.$route.query.redirect : '/')
      }).catch((error) => {
        this.show = true
        this.loader = false
        this.error = error.message
      });
    },
    resetPassword: function() {
      this.error = null
      this.success = null
      auth.fb.sendPasswordResetEmail(this.form.email).then(() => {
        this.success = "Vous allez recevoir un mail afin de réinitialiser votre mot de passe"
      }).catch((error) => {
        if(error.code == 'auth/invalid-email') {
          this.error = "Email non valide"
        } else if(error.code == 'auth/user-not-found') {
          this.error = "Utilisateur introuvable"
        } else {
          this.error = error.message
        }
      });
    }
  }
}
</script>

<style>
.button {
  cursor: pointer;
}
</style>